import { HttpResult } from "widgets-for-react"
import { loadOverviewItems } from "../../../customPages/overviewPage/widgets/overviewWidget.api"
import { ParsedOverviewDetailItem } from "../../../customPages/overviewPage/widgets/overviewWidget.state"

export const loadRecentNews = async (): Promise<HttpResult<Immutable.List<ParsedOverviewDetailItem>>> => {
    const res = await loadOverviewItems("news", 4, undefined, 'block')
    if (res.kind != "result") return res  

    let paginatedData = res.value
    paginatedData = {
        ...paginatedData,
        items:paginatedData.items
            .filter(i => i.Link?.url != window.location.pathname)
            .take(3)
    }
    return {
        kind: 'result',
        status: 200,
        value: paginatedData.items
    }
  }